<template>
  <div class="event-detail" :class="{'watch':$route.name && $route.name == 'event_watch', 'dark-mode': video_state == $hisport.video_states.COMPLETED,'clip-editing': clip_creating_mode, 'tag-editing': tag_editing_mode}" >
    <nav class="top-floating-bar video-player" v-if="!!event && video_state == $hisport.video_states.COMPLETED">
      <div class="title">
        <div class="title-inner">
          <span class="title-inner-name">
            <span v-hg-event-title="{event, html:true}"/>
            <span class="subtitle">
              <span class="score" v-if="event.event_type == $hisport.event_types.MATCH && event.score_team_home != undefined && event.score_team_foreign != undefined">
                <span>{{event.score_team_home}}</span>
                <small>:</small>
                <span>{{event.score_team_foreign}}</span>
              </span>
              &nbsp;-&nbsp;
              <span class="datetime">{{event.start_timestamp | moment("ddd D MMM")}}</span>
            </span>

            
          </span>
          <!-- <div class="match-title"> -->
            <!-- </div> -->
        </div>
      </div>
      <div class="icon-right" v-if="false">
          <help/>
      </div>
      <div class="action"  v-if="clip_creating_mode && !processing" >
        <a href="javascript: void 0" :disabled="selected_tag.markers.length < 3" @click="processClip()">
            <font-awesome-icon :icon="['fas','save']"/>
          <span v-i18n="'SAVE_CLIP'"/>
        </a>
        <span style="width: 220px;display: inline-block;flex: 1 1 auto;" />
        <a href="javascript: void 0" @click="abortClipCreating()">
          <font-awesome-icon :icon="['fas','times']" size="lg"/>
          <span v-i18n="'ABORT_CLIP'"/>
        </a>
      </div>
      <div class="action" v-if="clip_creating_mode && processing">
        <font-awesome-icon :icon="['fas','futbol']" spin size="3x"/>
      </div>
      <!-- <a href="javascript: void 0"  class="action" v-if="tag_editing_mode" @click="tag_editing_mode = false">
        <font-awesome-icon :icon="['fas','times']" size="lg"/>
      </a>
      <a href="javascript: void 0"  class="action" @click="tag_editing_mode = false" v-if="tag_editing_mode && video_state == $hisport.video_states.COMPLETED">
          <font-awesome-icon :icon="['fas','save']"/>
      </a> -->


      <a  href="javascript: void 0"  class="action"  @click="startClipEditing()"  
          v-if="!$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG && video_state == $hisport.video_states.COMPLETED && enableTagClip && !clip_creating_mode && !tag_editing_mode">
        <font-awesome-icon :icon="['fas','play']"/>
        <span v-i18n="'CREATE_CLIP'"/>
      </a>
<!-- 
      <a  href="javascript: void 0"  class="action"  
          v-if="video_state == $hisport.video_states.COMPLETED && !clip_creating_mode && !tag_editing_mode && !!autozoom">
        <font-awesome-icon :icon="['fas','stop']"/>
        <span v-i18n="'AUTOZOOM'"/>
      </a> -->

      
    </nav>
    <event-status-check :event="event" 
                        :request-password="requestPassword" 
                        :not-authorized="notAuthorized"
                        :loading="loading"
                        :processing="processing"
                        :enableEdit="enableEdit"
                        @password="init($event)"
                        ref="eventStatusCheck">
      <div class="video-wrapper">
        <div class="player-tags">
          <extended-video-player  	:event="event"
                                    :markerThresholds="markerThresholds" 
                                    :selected-tag="selected_tag" 
                                    :editing-tag="editing_tag" 
                                    :edit-mode="clip_creating_mode"
                                    :tag-types="tagTypes" 
                                    :enable-tag-clip="enableTagClip"
                                    :enable-edit="enableEdit"
                                    :enable-autozoom="!$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG && $hisport.options.platform.CONFIGURATION.ENABLE_AUTOZOOM"
                                    :autozoom="autozoom"
                                    @edit="$router.push('/events/' + event.id + '/edit')"
                                    @toggleTagList="tagsVisible = $event;" 
                                    @duration="duration = $event"
                                    @currentTime="current_time = $event"
                                    @draw="onDraw"
                                    @download="onDownload"
                                    @showInfo="onShowInfo"
                                    @requestAutozoom="requestAutozoom"
                                    ref="extendedVideoPlayer"/>
          <div class="tags-wrapper" v-show="tagsVisible && !clip_creating_mode">
            <tags-box ref="tagsBox" 
                      @close="tagsVisible = false"
                      :event="event" 
                      :marker-thresholds="markerThresholds"
                      :mentionable-users="mentionableUsers"
                      :tag-types="tagTypes"
                      :current-time="current_time"
                      :duration="duration"
                      :clip-creating-mode="clip_creating_mode" 
                      :enable-tag-clip="enableTagClip"
                      :on-tag-add="onTagAdded" 
                      :on-tag-update="onTagUpdated" 
                      :on-tag-remove="onTagRemoved"
                      :on-tag-select="selectTag"
                      :on-tag-edit="editTag"
                      :on-marker-click="gotoMarker"
                      :on-marker-remove="removeMarker"/>
          </div>
        </div>
      </div>
    </event-status-check>
    <!-- <modal-adaptive /> -->
  </div>
</template>
<script>
import { CONSTANTS }        from "morpheos.hisport.vueplugin"
import eventStatusCheck from "../_components/event_status_check"
import extendedVideoPlayer  from "../_components/extended_video_player/index"
import tagsBox              from "../_components/tags_box"
import help                 from "../_components/help"
// import modalAdaptive        from '../_components/modal_adaptive.vue';
export default {
  title(){
      if(this.event) 
        return this.$hisport.eventTitle(this.event, {html: false})
      return "LOADING_EVENT"
  },
  components: {
    eventStatusCheck,
    extendedVideoPlayer,
    tagsBox,
    // modalAdaptive,
    help
  },
  data(){
    return {
      markerInterval:       2, 
      markerThresholds:     0.1,
      enableTagClip:        false,
      enableEdit:           false,
      event:              	null,
      video_state:        	null,
      hibox_status:         {},
      selected_tag:       	null,
      editing_tag:			    null,
      processing:         	false,
      clip_creating_mode: 	false,
      tag_editing_mode:   	false,
      duration:				      0,
      current_time:			    0,

      tagTypes:  [],
      mentionableUsers: [],
      tagsVisible:          false,
      requestPassword:      false,
      notAuthorized:        false,
      password:             this.$route.query.password,
      event_poll_timeout:   null,

      loading: true,
      autozoom: null
    }
  },
  mounted: function(){
    if(this.$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG)
      return this.$router.replace("/videos/clips/by-event/" + this.$route.params.id)
    this.init(this.password);
  },
  watch:{
    "$route.params.id": function(){
      this.init(this.password);
    }
  },
  methods: {
    init(password){
      var self = this;
      clearTimeout(this.event_poll_timeout)
      this.requestPassword = false;
      this.loading = true;
      var opts = {
          include: [
            "event.video", 
            "event.teams", 
            // "event.users", 
            "event.game_field", 
            "event.tags", 
            "tag.tag_type",
            "game_field.structure",
            // "team.club",
            // "club.users"
          ],
          password: password,
          params: [{name: "id_user", value: this.$hisport.getUserId()}]
      }
      if(this.$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG){
        opts.include.push("event.clips")
      }
      this.$hisport.datacontext.event.getById(this.$route.params.id, opts)
      .then(function(event){
          self.event = event;
          if(event.game_field && event.game_field.structure){
            self.enableEdit = self.$hisport.permissions.updateStructure(event.game_field.structure.id)
          }
          if(!self.enableEdit && event.team_home && event.team_home.club){
            self.enableEdit = self.$hisport.permissions.updateClub(event.team_home.club.id)
          }
          if(!event.video && self.enableEdit)
            self.$router.replace({path: "/events/" + event.id + "/edit" })
          self.duration = event.end_timestamp - event.start_timestamp;
          if(self.$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG){
            self.enableTagClip = true;
          }else{
            self.enableTagClip = self.$hisport.permissions.canTagClipHighlight(self.event);
          }
          if(event.video){
            self.video_state = event.video.state;
          }
          if(self.video_state == self.$hisport.video_states.COMPLETED){
            self.reorderTags();
            if(!self.$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG && self.$hisport.options.platform.CONFIGURATION.ENABLE_AUTOZOOM){ 
              self.getAutozoom();
            }
            ["team_home", "team_foreign"]
            .forEach(function(k){
              if(event[k] && event[k].club && Array.isArray(event[k].club.users)){
                var all_users = event[k].club.users;

                var filtered_users = all_users.filter(function(x){ 
                                      return x && 
                                            Array.isArray(x.contracts) && 
                                            x.contracts.find(function(c){ 
                                              return c.contract_type == self.$hisport.contract_types.ALLOWED_USER_CLUB_SUPPORTER; 
                                            })
                                      })
                self.mentionableUsers = self.mentionableUsers.concat(filtered_users);
              }
            })
            self.$hisport.datacontext.tag_type.getAll({
                page_size: 100, 
                column_filters:{
                    id_sport: { 
                        $in: [0].concat(self.event.sports) 
                    }
                }
            }).then(function(tag_types){
              if(tag_types && Array.isArray(tag_types.entries)){
                self.tagTypes = tag_types.entries.filter(x=>x.id_sport != 0);
                if(self.tagTypes.length == 0){
                  self.tagTypes = tag_types.entries.filter(x=>x.id_sport == 0);
                }
              }
            })
          }else{
            self.event_poll_timeout = setTimeout(function(){ self.init(password) }, 5000)
          }
          self.loading = false;
          self.$store.dispatch("setLoading", false);
        })
      .catch(function(error){
          if(error.response.data.errors.indexOf("NEED_PASSWORD")>=0){
            self.requestPassword = true;
          }else if(error.response.data.errors.indexOf("NOT_AUTHORIZED")>=0){
            self.notAuthorized = true;
          }
          self.loading = false;
          self.$store.dispatch("setLoading", false);
        })
    },
    onShowInfo: function(){
      if(this.$refs.eventStatusCheck) 
        this.$refs.eventStatusCheck.showEventInfo();
      else
        console.log("NO REF")
    },
    onDownload: function(url){
      var title = this.event.title;
      if(!url){
        var entity = this.event.video;
        if(this.selected_tag && this.event && Array.isArray(this.event.clips)){
          var clip = this.event.clips.find(x=>x.id_tag == this.selected_tag.id);
          if(clip){
            entity = clip;
            title += " - " + clip.id;
          }
        }
        url = this.$hisport.options.helpers.getVideoUrl(entity, 'hd', false); //or this.$refs.video.src
        console.log("BY VIDEO SRC", url);
      }else{
        console.log("BY ARGUMENT", url)
      }

      if(!url) return console.warn("NO_URL")
      var anchor = document.createElement("a");
      anchor.setAttribute("href", url);
      //Questo attributo è valido solo per url dello stesso dominio
      anchor.setAttribute("download", title); //this.getVideoUrl();
      anchor.setAttribute("target", "_blank")
      anchor.click();
      
      
      // fetch(url)
      // .then(resp => resp.blob())
      // .then(blob => {
      //   const durl = window.URL.createObjectURL(blob);
      //   const a = document.createElement('a');
      //   a.style.display = 'none';
      //   a.href = durl;
      //   // the filename you want
      //   a.download = title;
      //   document.body.appendChild(a);
      //   a.click();
      //   window.URL.revokeObjectURL(durl);
      //   console.log("Download started", durl);
      //   // alert('your file has downloaded!'); // or you know, something with better UX...
      // })
      // .catch(function(error){
      //   console.error("Error in download", error);
      // });
    },
    onDraw: function(m){
      var options = this.$refs.extendedVideoPlayer.getOptions();
      var ratio_w = this.event.video.width - options.preview.width;
      var ratio_h = this.event.video.height - options.preview.height;
      var px = (1 - (m.x/(options.max_x * 2) + 0.5)) * ratio_w;
      var py = (1 - (m.y/(options.max_y * 2) + 0.5)) * ratio_h;
      var marker = {
        id_tag:       this.selected_tag.id,
        id_event:     this.event.id,
        id_video:     this.event.video.id,
        id_creator:   this.$hisport.getUserId(),
        x:            px,
        y:            py,
        z:            m.z || 1,
        r:            m.r || 0,
        ts:           m.ts,
        media:        m.media,
      }
      this.$hisport.datacontext.markers.add(marker)
        .then(function(info){console.log(info)})
        .catch(function(err){console.error(err)})
    },

    selectTag: function(tag){
      if(this.clip_creating_mode){
        if(this.selected_tag && tag && this.selected_tag.id == tag.id)
          return;
        else 
          this.abortClipCreating();
      }
      if(this.selected_tag && (!tag || this.selected_tag.id == tag.id))
        return this.selected_tag = null;

      this.selected_tag = tag;
    },
    editTag: function(tag){
      this.editing_tag = tag;
    },
    addTag: function(arg){
      return this.$refs.tagsBox.addTag(arg);
    },
    reorderTags: function(){
      if(Array.isArray(this.event.tags)){
        this.event.tags.sort(function(a,b){
            if(a.start_time<b.start_time) return -1
            return 1
        });
      }
    },
    onTagAdded: function(tag){
      var self = this;
      tag.id_event = this.event.id;
      if(this.event.video)
        tag.id_video = this.event.video.id;
      this.$hisport.datacontext.tag.add(tag)
      .then(function(tag){
        self.event.tags.push(tag);
        self.reorderTags();
        self.$refs.tagsBox.exitEditing();
      })
      .catch(function(error){
          console.error(error)
      })
    },
    onTagUpdated: function(tag){
      var self = this;
      tag.id_event = this.event.id;
      if(this.event.video)
        tag.id_video = this.event.video.id;
      this.$hisport.datacontext.tag.update(tag)
      .then(function(tag){
        var idx = self.event.tags.findIndex(t=>t.id == tag.id);
        self.$set(self.event.tags, idx, tag);
        self.reorderTags();
        self.$refs.tagsBox.exitEditing();
      })
      .catch(function(error){
        console.error(error)
      })
    },
    onTagRemoved: function(tag){
      var self = this;
      this.$hisport.datacontext.tag.remove(tag.id)
      .then(function(){
        var idx = self.event.tags.findIndex(t=>t.id == tag.id);
        self.event.tags.splice(idx, 1)
        self.reorderTags();
        self.$refs.tagsBox.exitEditing();
      })
      .catch(function(error){
        console.error(error)
      })
    },
    abortClipCreating: function(){
      if(this.$refs.extendedVideoPlayer.getMarkers().filter(function(x){return !x.locked}).length>0){
        var toret = confirm(this.$options.filters.i18n("ABORT_CLIP_CREATING"))
        if(toret){
          this.clip_creating_mode = false;
          this.selected_tag = null;
          setTimeout(this.$refs.extendedVideoPlayer.changedEditMode, 10);
          return true;
        }else{
          return false;
        }
      }else{
        this.clip_creating_mode = false
        this.selected_tag = null;
        setTimeout(this.$refs.extendedVideoPlayer.changedEditMode, 10)
        return true;
      }
    },
    getMarkersAbsolute: function(){
      if(!this.$refs.extendedVideoPlayer) return [];
      var markers = this.$refs.extendedVideoPlayer.getMarkers();
      var options = this.$refs.extendedVideoPlayer.getOptions();
      var max_w = this.event.video.width - CONSTANTS.CLIP_SIZE.WIDTH;
      var max_h = this.event.video.height - CONSTANTS.CLIP_SIZE.HEIGHT;
      return markers.map(function(m){
        var px = (1 - (m.x/(options.max_x * 2) + 0.5)) * max_w;
        var py = (1 - (m.y/(options.max_y * 2) + 0.5)) * max_h;
        return {
            x:  px,
            y:  py,
            z:  1,
            ts: m.ts
        }
      })
    },
    createClip: function(clip){
      var self = this;
      self.$hisport.datacontext.clip.create(clip)
          .then(function(response){
            self.clip_creating_mode = false;
            self.selected_tag = null;
            self.$refs.extendedVideoPlayer.changedEditMode();
            self.processing = false;
            return self.$modal.show(
              ()=>import("../_components/hg_modal"), 
              { info: "CLIP_SUCCESS", html: response}
            );
          })
          .catch(function (error) {
            console.error(error);
            return self.$modal.show(
              ()=>import("../_components/hg_modal"), 
              { error: "CLIP_ERROR", html: error }
            );
          });
    },
    getFrame(){
      var self = this;
      return new Promise(function(resolve, reject){
        if( !self.$refs || 
            !self.$refs.extendedVideoPlayer ||
            typeof self.$refs.extendedVideoPlayer.getCurrentFrameAsImage != "function")
          return reject("INVALID_COMPONENT")
        self.$refs.extendedVideoPlayer.getCurrentFrameAsImage()
        .then(resolve)
        .catch(reject)
      })
    },
    processClip: async function(){
      if(this.selected_tag.markers.length < 3)
        return this.$modal.show(
          ()=>import("../_components/hg_modal"), 
          { error: "CLIP_NO_MARKERS" }
        );
      var self = this;
      this.processing = true;
      var _clip = {
        preview:      "",
        title:        "Clip " + (new Date()).toJSON(),
        id_tag:       self.selected_tag.id,
        id_event:     self.event.id,
        id_video:     self.event.video.id,
        id_external:  self.event.video.id_external,
        id_creator:   self.$hisport.getUserId(),
        markers:      self.getMarkersAbsolute()
      }
      //Errore in Firefox 27/09/21
      // try{
      //   _clip.preview = await self.getFrame()
      // }catch(ex){
      //   console.error("Error generating frame", ex)
      // }
      //-----------------------------
      if(!self.selected_tag.id){
        var tag = await self.$hisport.datacontext.tag.add(self.selected_tag);
        _clip.id_tag = tag.id;
      }
      
      self.createClip(_clip)
    },
    startClipEditing: function(){
      if(this.tag_editing_mode && !this.abortTagEditing())
        return;
      if(!this.selected_tag){
        this.selected_tag = this.addTag(true);
        return setTimeout(this.startClipEditing, 100);
      }
      this.clip_creating_mode = true;
      setTimeout(this.$refs.extendedVideoPlayer.changedEditMode, 200)
    },
    abortTagEditing: function(){
      if(!this.selected_tag.id)
        this.selected_tag = null;
      this.tag_editing_mode = false;
      return true;
    },
    startTagEditing: function(){
      if(this.clip_creating_mode && !this.abortClipCreating())
        return;
      else if(this.selected_tag){
        this.tag_editing_mode = true;  
      }
    },

    removeMarker: function(m){
      this.$refs.extendedVideoPlayer.removeMarkerById(m.id);
    },
    gotoMarker: function(m){
      this.$refs.extendedVideoPlayer.gotoMarkerById(m.id);
    },
    requestAutozoom: function(){
      var self = this;
      this.$hisport.datacontext.http.post("/events/autozoom/" + this.event.id)
      .then(function(response){
        alert("Autozoom sent succesfully for event " + self.event.id + "\r\nResponse is: " + response.data);
      })
      .catch(function(error){
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          if(Array.isArray(error.response.data.errors)){
            alert("Autozoom sent with error for event " + self.event.id + "\r\nResponse is: " + error.response.data.errors.join("\r\n"));
          }else{
            alert("Autozoom sent with error for event " + self.event.id + "\r\nSee console log for details");
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
          alert("Autozoom sent with error for event " + self.event.id + "\r\nNo response received");
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          alert("Autozoom sent with error for event " + self.event.id + "\r\nInternal error " + error.message);
        }
      })
    },
    getAutozoom: function(){
      var self = this;
      var url = self.event.video.storage_url + "/autozoom.json";
      this.$hisport.datacontext.http.get(url)
      .then(function(response){
        if(response.data && Array.isArray(response.data.results) && response.data.results.length>0)
          self.autozoom = response.data;
          window.autozoom = self.autozoom;
          self.autozoom.results = self.autozoom.results.filter(function(x, idx){
                                          return  idx % 50 === 0
                                        })
                                        .reduce(function(acc, m){
                                          var v = {
                                              ts: m.ts,
                                              z:  m.z,
                                              x:  50 - m.x * 100, //25 - m.x * 50,
                                              y:  50 - m.y * 100//(m.y / ratio_h + 0.5) * options.max_y * 2
                                          }
                                          if(acc.length>0){
                                            var prev = acc[acc.length - 1];
                                            if(prev && 
                                               (v.ts - prev.ts) < 1 &&
                                               (v.x - prev.x) < 0.1
                                            ){
                                              //Skip
                                            }else{
                                              acc.push(v)
                                            }
                                          }else{
                                            acc.push(v);
                                          }
                                          return acc;
                                        }, [])
      })
      .catch(function(error){
          self.autozoom = { errored: true }
          console.error("Error fetching autozoom info", error)
      })
    }
  }
}
</script>
<style>
nav.video-player{
  top:0;
  opacity:1;
  transition: top 0.7s ease-in-out,
              opacity 0.7s ease-in-out;
}
.hg-timeline,
.hg-media-controls{
  opacity:1;
  transition: opacity 0.7s ease-in-out;
}

.tags-wrapper{
  position:absolute;
  top:0px;
  right:0;
  width:400px;
  height:calc(100% - 140px);
  z-index:999;
  opacity:1;
  background-image: linear-gradient(to bottom, rgba(44, 62, 80, 1), rgba(44, 62, 80, .4) 90%, rgba(44, 62, 80, .1) 99%);
  transition: right 0.7s ease-in-out,
              opacity 0.7s ease-in-out;
}

.user-stopped nav.video-player{top: -120px;opacity: 0;}
.user-stopped .hg-timeline,
.user-stopped .hg-media-controls{opacity: 0;}
.user-stopped .tags-wrapper{right: -450px;opacity: 0;}
.event-detail .show-event-info{
  cursor: pointer;

} 
.event-detail .hg-player video{
  width:calc( 100vw - var(--sidebar-width) )!important;
}

.bypass .hg-player video,
.bypass .hg-player .video-js.vjs-default-skin{
  width: 100vw!important;
}
.event-detail .row{
  display:flex;
  flex-wrap: wrap;
}
.event-detail .row .cell{
  flex: 1 1 auto;
  width: 50%;
}
/* scrolltable rules */
.event-detail table.scrollable  { width:auto; margin-top:  20px; display: inline-block; overflow-x: auto; overflow-y:scroll; height:200px;}
.event-detail table.scrollable th div { margin-top: -20px; position: absolute; }
/* design */
/* .event-detail table.scrollable table { border-collapse: collapse; }
.event-detail table.scrollable tr:nth-child(even) { background: #EEE; } */

.top-floating-bar{
  padding:10px 0;
  position:absolute;
  z-index:99;
  left:calc(50% - 250px);
  right:auto;
  width:500px;
  font-weight:bold;
  background:rgb(44, 62, 80, .5);
  border-radius:0 0 10px 10px;
  display:flex;
  flex-direction: column;
}
.logged-user .top-floating-bar{
  left:calc(50% - 250px + var(--sidebar-width) / 2);
}
.top-floating-bar .title{
  margin-bottom:10px;
}
.top-floating-bar .action{
  background: var(--hg-red);
  color: var(--white);
  position:relative;
  top:10px;
  padding:5px;
  display:block;
  width:100%;
  text-decoration: none;
  border-radius: 0 0 10px 10px;
}
.top-floating-bar .action *+*{
  margin-left:5px;
}
.top-floating-bar .action a{
  color:var(--white);
  text-decoration: none;
}
.event-detail .player-tags{
  position:relative;
}
.event-detail .video-media-info{
  padding:20px;
}
.event-detail .video-media-info h3{
  border-bottom:1px solid rgba(255,255,255,.5);
  text-align:left;
  font-size:x-large;
}
.event-detail .video-media-info table{
  width:100%;
  border-spacing: 0px;
  border-collapse:collapse;
  font-family: 'Courier New', Courier, monospace;
  font-size:12px;
}
.event-detail .video-media-info table th,
.event-detail .video-media-info table td{
  padding:4px;
  text-align:left;
  vertical-align: top;
  white-space:nowrap;
  margin:0;
}
.event-detail .video-media-info table.table-video-media-info-chunks th,
.event-detail .video-media-info table.table-video-media-info-chunks td{
  text-align:left;
}

.event-detail .video-media-info table th:first-child,
.event-detail .video-media-info table td:first-child{
  padding-left:0;
}
.event-detail .video-media-info table th:last-child,
.event-detail .video-media-info table td:last-child{
  padding-right:0;
}
.event-detail .video-media-info table td.wrap{
  white-space: normal;;
}

.event-detail .video-media-info table tr.error{
  color: red;
}
.event-detail .video-media-info table tr.warn{
  color: orange;
}
.event-detail .video-media-info table{
  text-align:left;
  vertical-align: top;
}
.event-detail .processing{
  position:absolute;
  background:rgba(255,255,255,.9);
  top: 0px;
  width:100%;
  height:100%;
  padding:25vh;
  z-index:99999;
  font-weight:bold;
}
.event-detail.tag-editing .hg-tag-list .tag.edit{
  padding-left:5px;
  padding-top:5px;
  min-height: 120px;
}
.event-detail.clip-editing .hg-tag-list .tag-wrapper:not(.selected){
  display:none;
}
.event-detail.clip-editing .hg-tag-list .tag-wrapper.selected.has-markers .tag{
  min-height:200px;
  height:auto;
}
.event-detail .favourite img{
  height: 24px;
  width:  24px;
}
.event-detail .save{
  width: 150px!important;
}
.event-detail .save button{
  width:100px;
}
.event-detail .bar{
  height: 90px;
  padding: 32px;
  display:flex;
  width:100%;
}
.event-detail .btn-autohl{
  border-radius:24px!important;
  font-weight:bold;
  line-height: 23px;
  display: flex;
  justify-content:space-around;
}
.event-detail .event-tag-wrapper{
  height: calc(100vh - var(--top-navbar-width));
  position:relative;
}
.event-detail .frameset{
  display: flex;
  flex-direction: row;
  position: relative;
  height: calc(100vh - 88px);
  overflow: auto;
}
.event-detail .frame-body{
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 1;
	flex-basis: auto;
	width: calc(100% - 350px)
}
.event-detail .frame-tags{
	display: flex;
  flex-direction: column;
  width: 350px;
  border-left: 2px solid var(--light-grey);
  height: 100%;
  text-align: left;
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
}
.event-detail.dark-mode  .frame-tags{
  border-left-color: rgba(255,255,255,.15);
}
.event-detail .actions{
  flex: 1 1 auto;
  text-align:left;
}
.event-detail .bar .score{
  font-size:36px;
  font-weight: bold;
}
.event-detail .bar .score small{
  color:var(--grey);
  font-size:20px;
  line-height:10px;
  position:relative;
  top:-6px;
}
.event-detail .bar .score span{
  margin: 0 5px;
}
@media only screen and (max-width: 850px) {
  .event-detail.watch{
    height:90vh;
  }
}
</style>
